// extracted by mini-css-extract-plugin
export var card = "_bo-c";
export var checkmark = "_bo-k";
export var childrenContainer = "_bo-6";
export var container = "_bo-b";
export var disabled = "_bo-9";
export var disabledChildren = "_bo-a";
export var focused = "_bo-1";
export var gray = "_bo-r";
export var green = "_bo-o";
export var icon = "_bo-g";
export var iconWrapper = "_bo-8";
export var imageCircle = "_bo-s";
export var large = "_bo-5";
export var lg = "_bo-j";
export var listItemContainer = "_bo-0";
export var md = "_bo-i";
export var medium = "_bo-4";
export var menu = "_bo-f";
export var red = "_bo-p";
export var rightArea = "_bo-7";
export var sectionContainer = "_bo-e _bo-b";
export var selected = "_bo-d";
export var sm = "_bo-h";
export var small = "_bo-3";
export var statusDot = "_bo-n";
export var statusDotContainer = "_bo-m";
export var text = "_bo-l";
export var xs = "_bo-2";
export var yellow = "_bo-q";